import {lazy, useState} from 'react';

import ErrorBoundary from '@patientpattern/coat/ui/ErrorBoundary';
import useInterval from '@patientpattern/utils/hooks/useInterval';
import {useIdleTimer} from 'react-idle-timer';
import {Outlet, ScrollRestoration} from 'react-router-dom';

import usePageTracking from 'analytics/usePageTracking';
import {
    onBroadcastChannelMessage,
    onBroadcastChannelPostMessage,
} from 'app/broadcastChannel';
import {useRefreshToken} from 'user/api';
import SessionExpirationModal from 'user/SessionExpirationModal';
import {useUserStore} from 'user/store';

const AppLegacy = lazy(() => import('legacy/App'));

const Index = () => {
    const {idleWarnAfter, idleExpireAfter, authRefreshInterval} = useUserStore(
        state => state.environment,
    );
    const {mutate: refreshToken} = useRefreshToken();
    const [showIdleModal, setShowIdleModal] = useState(false);

    const onIdle = () => {
        // only show session expiration modal in deployed environments or testing after configured amount of idle time
        if (!import.meta.env.DEV || window.Cypress) {
            setShowIdleModal(true);
        }
    };
    const onHideIdleModal = () => {
        onBroadcastChannelPostMessage();
        setShowIdleModal(false);
    };

    onBroadcastChannelMessage(() => {
        setShowIdleModal(false);
    });

    usePageTracking();

    useIdleTimer({
        crossTab: true,
        debounce: 1000,
        onIdle,
        syncTimers: 200, // 200 is recommended by the library. see https://idletimer.dev/docs/getting-started/new#simplified-cross-tab-api
        timeout: idleWarnAfter,
    });

    useInterval(refreshToken, authRefreshInterval);

    return (
        <AppLegacy>
            <ScrollRestoration />
            <ErrorBoundary>
                <Outlet />
            </ErrorBoundary>
            <SessionExpirationModal
                expireAfter={idleExpireAfter - idleWarnAfter}
                isOpen={showIdleModal}
                onClose={onHideIdleModal}
            />
        </AppLegacy>
    );
};

export default Index;
